import { css } from '@emotion/react'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type HTMLAttributes, forwardRef } from 'react'

export interface ScanQRCodeTutorialProps
	extends Omit<HTMLAttributes<HTMLDivElement>, keyof HTMLMotionProps<'div'>>,
		HTMLMotionProps<'div'> {}

interface AnimatedImageProps {
	src: string
	initialPosition: {
		y: number
		x: number
	}
	animatePosition: {
		y: number
		rotate: string
	}
	delay: number
}

// 处理单个动画图片的子组件
function AnimatedImage({ src, initialPosition, animatePosition, delay }: AnimatedImageProps) {
	return (
		<motion.img
			src={src}
			css={css`
				width: 250px;
				object-fit: contain;
				height: fit-content;
				border: 16px solid var(--bg-body-base-1);
				box-shadow: 0 4px 32px 0 var(--solid-shadow-1);
				border-radius: 12px;
			`}
			initial={{
				opacity: 0,
				...initialPosition,
			}}
			animate={{
				opacity: 1,
				...animatePosition,
				transition: {
					delay,
					type: 'spring',
					duration: 1,
				},
			}}
		/>
	)
}

export default forwardRef<HTMLDivElement, ScanQRCodeTutorialProps>(function ScanQRCodeTutorial(
	{ ...props }: ScanQRCodeTutorialProps,
	ref
) {
	return (
		<motion.div
			ref={ref}
			css={css`
				display: flex;
				gap: 20px;
				align-items: center;
			`}
			{...props}
		>
			<AnimatedImage
				src="https://cdnv2.ruguoapp.com/FqWRam4o2IY5XaCjYF5LZJqEfVJI.jpeg"
				initialPosition={{ y: -100, x: 40 }}
				animatePosition={{ y: -60, rotate: '-10deg' }}
				delay={0.3}
			/>
			<AnimatedImage
				src="https://cdnv2.ruguoapp.com/FiOi_lJazChl4V1xwf_f1C72YbGR.jpeg"
				initialPosition={{ y: 100, x: -40 }}
				animatePosition={{ y: 60, rotate: '10deg' }}
				delay={1.3}
			/>
		</motion.div>
	)
})
